import React, { useState } from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import DateTimeTab from './tabs/DateTimeTab';
import VisualTab from './tabs/VisualTab';
import DisplayTab from './tabs/DisplayTab';
import EmailsTab from './tabs/EmailsTab';
import './AdminPanel.css';

const AdminPanel = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState('datetime');
  const { logout } = useSettings();

  const handleLogout = () => {
    logout();
    onClose();
  };

  const tabs = [
    { id: 'datetime', label: 'Date & Time', icon: '📅' },
    { id: 'visual', label: 'Visual', icon: '🎨' },
    { id: 'display', label: 'Display', icon: '📺' },
    { id: 'emails', label: 'Emails', icon: '📧' }
  ];

  return (
    <div className="admin-panel-overlay">
      <div className="admin-panel">
        {/* Header */}
        <div className="admin-panel-header">
          <h2>Admin Control Panel</h2>
          <div className="header-actions">
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
            <button className="close-panel-btn" onClick={onClose}>
              ×
            </button>
          </div>
        </div>

        {/* Tabs */}
        <div className="admin-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="admin-content">
          {activeTab === 'datetime' && <DateTimeTab />}
          {activeTab === 'visual' && <VisualTab />}
          {activeTab === 'display' && <DisplayTab />}
          {activeTab === 'emails' && <EmailsTab />}
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;